<template>
	<div>
		<transition name="fade" mode="out-in">
			<div>
				<img :src="images[currentImage]" :key="images[currentImage]" alt="transitioning image">
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'ImagesTransition',
	data () {
		return {
			currentImage: 0
		}
	},
	props: {
		images: {
			type: Array,
			required: true
		},
		transitionDuration: {
			type: Number,
			default: 3000
		}
	},
	mounted () {
		setInterval(() => {
			this.currentImage = (this.currentImage + 1) % this.images.length
		}, this.transitionDuration)
	}
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

img {
  width: 100%; /* make the image fill the width of its container */
  height: 300px; /* keep the original aspect ratio */
  object-fit: cover; /* cover the entire area of the container without distorting the aspect ratio */
	object-position: center; /* center the image */
	border-radius: $border-radius;
	position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

div {
	width: 100%;
	height: 300px;
	position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/utils/ImagesTransition.vue